import type { CplZone } from '@lcc/shared';
import { clsx } from 'clsx';

const ZONE_CONFIG: Record<CplZone, { label: string; classes: string }> = {
  green: { label: 'GREEN', classes: 'bg-[#EAF3DE] text-[#173404] border-[#4A7C2A]' },
  yellow: { label: 'YELLOW', classes: 'bg-[#FAEEDA] text-[#412402] border-[#B07F1A]' },
  orange: { label: 'ORANGE', classes: 'bg-[#FAECE7] text-[#4A1B0C] border-[#B85420]' },
  red: { label: 'RED', classes: 'bg-[#FCEBEB] text-[#501313] border-[#A32D2D]' },
};

interface Props {
  zone: CplZone | null;
  size?: 'sm' | 'md' | 'lg';
}

export function ZoneBadge({ zone, size = 'md' }: Props) {
  if (!zone) return <span className="text-gray-400 text-xs">No data</span>;

  const { label, classes } = ZONE_CONFIG[zone];
  return (
    <span
      className={clsx(
        'inline-flex items-center border font-mono font-semibold tracking-wider rounded',
        classes,
        size === 'sm' && 'text-xs px-2 py-0.5',
        size === 'md' && 'text-sm px-3 py-1',
        size === 'lg' && 'text-lg px-4 py-2'
      )}
    >
      {label}
    </span>
  );
}
